import React from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Skills from './components/Skills';

import Contact from './components/Contact';
import Footer from './components/Footer';
import Header from './components/Header';

function App() {
  return (
    <div>
      <Header />
      <Hero />
      <div className="main-content">
        <About />
        <Services />
        <Skills />
        
        <Contact />
      </div>
      <Footer />
    </div>
  );
}

export default App;
